<template>
  <article>
    <div class="flex flex-row gap-2 leading-tightest no-underline color-current">
      <div class="flex-shrink-0 text-gray-500 i-tabler-circle-dot inline-block w-5 h-5" />
      <div class="rounded-full h-4 bg-gray-500 w-70" />
    </div>
  </article>
</template>
